import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, UserUpdate } from '../../../shared/interfaces/user.interfaces';
import { Observable } from 'rxjs';

const basePath = '/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  // Gets the current user's details
  getUser(): Observable<User> {
    return this.http.get<User>(`${basePath}`);
  }

  // Updates the current user's details
  updateUser(payload: UserUpdate): Observable<User> {
    let params = new HttpParams();
    if (payload.user_id) {
      params = params.set('user_id', payload.user_id);
    }
    const body = {
      "name": payload?.name,
      "username": payload?.username,
      "phone": payload?.phone,
      "password": payload?.password
    };
    return this.http.put<User>(`${basePath}`, body, { params });
  }

}
